export enum Difficulty {
  easy = 'Easy',
  medium = 'Medium',
  hard = 'Hard'
}
